/**
 * DAS-41: 거래소 점검 일정 API 클라이언트
 */
import apiClient from "./apiClient";

/** 점검 일정 목록 조회 */
export const listSchedules = (params) =>
    apiClient.get("/api/maintenance/schedules/", { params });

/** 점검 일정 등록 */
export const createSchedule = (payload) =>
    apiClient.post("/api/maintenance/schedules/", payload);

/** 점검 일정 수정 (PATCH) */
export const updateSchedule = (id, payload) =>
    apiClient.patch(`/api/maintenance/schedules/${id}/`, payload);

/** 점검 일정 삭제 */
export const deleteSchedule = (id) =>
    apiClient.delete(`/api/maintenance/schedules/${id}/`);

/** 현재 활성(진행 중) 점검 목록 조회 */
export const getActiveMaintenance = () =>
    apiClient.get("/api/maintenance/active/");
